import { useEffect } from 'react';
import { useStore } from '@tmsw/powerups.store';
import { useTranslation } from '@tmsw/powerups.intl.hooks.use-translation';
import { useVieConfig } from '@tmsw/powerups.vie.hooks.use-vie-config';
import { VIEButton } from '../../components/Templates/VIE';
import { useSkipChapter } from '@tmsw/powerups.vie.hooks.use-skip-chapter';
import './Splash.css';
import { focusSettingsToggler } from '../../services/focusSettingsToggler';

function Splash() {
  const parentNode = 'SPLASH';
  const { __t } = useTranslation(parentNode);
  const skipChapter = useSkipChapter();
  const translatedConfig = __t('vieConfig');
  const { vieConfigRef, updateVieConfig } = useVieConfig();
  const { goToNextPage } = useVieConfig();
  // const viewport = useStore((state) => state.viewport);
  const setPageTitle = useStore((state) => state.setPageTitle);
  const showSettingsPanel = useStore((state) => state.showSettingsPanel);
  const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  const inPortrait = useStore((state) => state.inPortrait);

  useEffect(() => {
    focusSettingsToggler();
  }, []);

  useEffect(() => {
    setPageTitle(__t('pageTitle'));
  }, [showSettingsPanel, isPauseEnabled, inPortrait]);

  const SplashButtonTemplates = ({ onButtonClick, buttons }) => (
    <>
      <div className="splash-section">
        <div className="splash-content">
          {/* The logo image is added for accessibility purpose due to the actual logo embeded in video */}
          <img
            src={__t('logos.primary', 'GENERAL')}
            alt={__t('logoImageAlt', 'GENERAL')}
            className="splash-logo-img"
          />
          <VIEButton
            id="Button1"
            onButtonClick={onButtonClick}
            isCTAbtn
            className="vie-button"
            autoFocus
            buttonData={{
              ...buttons[0],
              ...{
                label: __t(buttons[0].label, 'GENERAL'),
                ariaLabel: __t(buttons[0].ariaLabel, 'GENERAL'),
              },
            }}
            style={{
              position: 'absolute',
              bottom: '15%',
              padding: `var(--ui-buttons-cta-button-padding)`,
            }}
            onClick={goToNextPage}
            tabIndex={0}
          />
          <div
            className="copyright-text-splash"
            style={{
              position: 'absolute',
              bottom: __t('market', 'GENERAL') === 'mea' ? '8%' : '10%',
              padding: `var(--ui-buttons-cta-button-padding)`,
              whiteSpace: 'pre-line',
              lineHeight: '0.85',
              fontWeight: 500,
            }}
          >
            {__t('market', 'GENERAL') === 'mea'
              ? __t('byLine.text', 'SPLASH')
              : __t('byLine.text', 'GENERAL')}
          </div>
        </div>
      </div>
    </>
  );

  const templates = {
    'Promo Intro - 1 button': ({ onButtonClick, buttons }) => (
      <SplashButtonTemplates
        onButtonClick={onButtonClick}
        buttons={buttons}
        logoImg={__t('logos.primary', 'GENERAL')}
        tabIndex={0}
      />
    ),
  };

  // initial load on mount
  useEffect(() => {
    updateVieConfig({
      ...translatedConfig,
      skipChapter: skipChapter,
      templates: templates,
    });
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  // custom update
  useEffect(() => {
    if (skipChapter !== vieConfigRef.current.skipChapter) {
      updateVieConfig({ skipChapter });
    }
  }, [skipChapter, updateVieConfig, vieConfigRef]);

  return null;
}
// Splash.whyDidYouRender = true;

export { Splash };
